import { RouteConfig } from 'vue-router';

const DetailsView = () => import('@/views/details.vue');

const DetailsBusinessViewIndex = () =>
  import('@/views/details/business/index.vue');

const DetailsBusinessTaxpayersIdView = () =>
  import('@/views/details/business/tax-payers/_id.vue');
const DetailsBusinessTaxpayersIdInfoView = () =>
  import('@/views/details/business/tax-payers/info.vue');
const DetailsBusinessTaxpayersIdIncomesView = () =>
  import('@/views/details/business/tax-payers/incomes.vue');
const DetailsBusinessTaxpayersIdChargesView = () =>
  import('@/views/details/business/tax-payers/charges.vue');

const DetailsBusinessPartnersIdView = () =>
  import('@/views/details/business/partners/_id.vue');
const DetailsBusinessPartnersIdInfoView = () =>
  import('@/views/details/business/partners/info.vue');
const DetailsBusinessPartnersIdIncomesView = () =>
  import('@/views/details/business/partners/incomes.vue');
const DetailsBusinessPartnersIdTaxesView = () =>
  import('@/views/details/business/partners/taxes.vue');

const DetailsSelfemployeeViewIndex = () =>
  import('@/views/details/self-employee/index.vue');

const DetailsSelfemployeeTaxpayersIdView = () =>
  import('@/views/details/self-employee/tax-payers/_id/index.vue');
const DetailsSelfemployeeTaxpayersIdInfoView = () =>
  import('@/views/details/self-employee/tax-payers/_id/info/index.vue');
const DetailsSelfemployeeTaxpayersIdInfoIncomeView = () =>
  import('@/views/details/self-employee/tax-payers/_id/info/income.vue');
const DetailsSelfemployeeTaxpayersIdInfoTaxesView = () =>
  import('@/views/details/self-employee/tax-payers/_id/info/taxes.vue');
const DetailsSelfemployeeTaxpayersIdPartnersView = () =>
  import('@/views/details/self-employee/tax-payers/_id/partners/index.vue');
const DetailsSelfemployeeTaxpayersIdPartnersIncomeTaxesView = () =>
  import(
    '@/views/details/self-employee/tax-payers/_id/partners/income-taxes.vue'
  );
const DetailsSelfemployeePartnersIdView = () =>
  import('@/views/details/self-employee/partners/_id.vue');

const DetailsPlatformsViewIndex = () =>
  import('@/views/details/platforms/index.vue');
const DetailsPlatformsTaxpayersIdView = () =>
  import('@/views/details/platforms/tax-payers/_id/index.vue');
const DetailsPlatformsTaxpayersIdInfoView = () =>
  import('@/views/details/platforms/tax-payers/_id/info/index.vue');
const DetailsPlatformsTaxpayersIdInfoIncomeView = () =>
  import('@/views/details/platforms/tax-payers/_id/info/income.vue');
const DetailsPlatformsTaxpayersIdInfoTaxesView = () =>
  import('@/views/details/platforms/tax-payers/_id/info/taxes.vue');

export default {
  path: '/details',
  component: DetailsView,
  children: [
    {
      path: 'platforms',
      name: 'details-platforms-index',
      component: DetailsPlatformsViewIndex,
      meta: {
        name: 'page.platforms',
      },
      children: [
        {
          path: 'taxpayers/:id',
          name: 'details-platforms-taxpayers-id',
          component: DetailsPlatformsTaxpayersIdView,
          redirect: { name: 'details-platforms-taxpayers-id-info' },
          meta: {
            name: 'section.taxPayers',
          },
          children: [
            {
              path: 'info',
              name: 'details-platforms-taxpayers-id-info',
              component: DetailsPlatformsTaxpayersIdInfoView,
            },
            {
              path: 'info/income',
              name: 'details-platforms-taxpayers-id-info-income',
              component: DetailsPlatformsTaxpayersIdInfoIncomeView,
            },
            {
              path: 'info/taxes',
              name: 'details-platforms-taxpayers-id-info-taxes',
              component: DetailsPlatformsTaxpayersIdInfoTaxesView,
            },
          ],
        },
      ],
    },
    {
      path: 'business',
      name: 'details-business-index',
      component: DetailsBusinessViewIndex,
      meta: {
        name: 'page.business',
      },
      children: [
        {
          path: 'taxpayers/:id',
          name: 'details-business-taxpayers-id',
          redirect: { name: 'details-business-taxpayers-id-info' },
          component: DetailsBusinessTaxpayersIdView,
          meta: {
            name: 'section.taxPayers',
          },
          children: [
            {
              path: 'info',
              name: 'details-business-taxpayers-id-info',
              component: DetailsBusinessTaxpayersIdInfoView,
            },
            {
              path: 'incomes',
              name: 'details-business-taxpayers-id-incomes',
              component: DetailsBusinessTaxpayersIdIncomesView,
            },
            {
              path: 'charges',
              name: 'details-business-taxpayers-id-charges',
              component: DetailsBusinessTaxpayersIdChargesView,
            },
          ],
        },
        {
          path: 'partners/:id',
          name: 'details-business-partners-id',
          redirect: { name: 'details-business-partners-id-info' },
          component: DetailsBusinessPartnersIdView,
          meta: {
            name: 'section.partners',
          },
          children: [
            {
              path: 'info',
              name: 'details-business-partners-id-info',
              component: DetailsBusinessPartnersIdInfoView,
            },
            {
              path: 'incomes',
              name: 'details-business-partners-id-incomes',
              component: DetailsBusinessPartnersIdIncomesView,
            },
            {
              path: 'charges',
              name: 'details-business-partners-id-taxes',
              component: DetailsBusinessPartnersIdTaxesView,
            },
          ],
        },
      ],
    },
    {
      path: 'self-employee',
      name: 'details-self-employee-index',
      redirect: { name: 'details-self-employee-taxpayers-id-info' },
      component: DetailsSelfemployeeViewIndex,
      meta: {
        name: 'page.selfEmployee',
      },
      children: [
        {
          path: 'taxpayers/:id',
          name: 'details-self-employee-taxpayers-id',
          redirect: { name: 'details-self-employee-taxpayers-id-info' },
          component: DetailsSelfemployeeTaxpayersIdView,
          meta: {
            name: 'section.taxPayers',
          },
          children: [
            {
              path: 'info',
              name: 'details-self-employee-taxpayers-id-info',
              component: DetailsSelfemployeeTaxpayersIdInfoView,
            },
            {
              path: 'info/income',
              name: 'details-self-employee-taxpayers-id-info-income',
              component: DetailsSelfemployeeTaxpayersIdInfoIncomeView,
            },
            {
              path: 'info/taxes',
              name: 'details-self-employee-taxpayers-id-info-taxes',
              component: DetailsSelfemployeeTaxpayersIdInfoTaxesView,
            },
            {
              path: 'partners',
              name: 'details-self-employee-taxpayers-id-partners',
              component: DetailsSelfemployeeTaxpayersIdPartnersView,
            },
            {
              path: 'partners/:partnerId/income-taxes',
              name: 'details-self-employee-taxpayers-id-partners-income-taxes',
              component: DetailsSelfemployeeTaxpayersIdPartnersIncomeTaxesView,
            },
          ],
        },
        {
          path: 'partners/:id',
          name: 'details-self-employee-partners-id',
          component: DetailsSelfemployeePartnersIdView,
          meta: {
            name: 'section.partners',
          },
        },
      ],
    },
  ],
} as RouteConfig;
